/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractTenantDocument } from './ContractTenantDocument';
import {
    ContractTenantDocumentFromJSON,
    ContractTenantDocumentFromJSONTyped,
    ContractTenantDocumentToJSON,
    ContractTenantDocumentToJSONTyped,
} from './ContractTenantDocument';

/**
 * 
 * @export
 * @interface ContractGuarantor
 */
export interface ContractGuarantor {
    /**
     * 
     * @type {string}
     * @memberof ContractGuarantor
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ContractGuarantor
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ContractGuarantor
     */
    civilityId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContractGuarantor
     */
    isCompleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContractGuarantor
     */
    employmentStatusId: string;
    /**
     * 
     * @type {Array<ContractTenantDocument>}
     * @memberof ContractGuarantor
     */
    documents: Array<ContractTenantDocument>;
}

/**
 * Check if a given object implements the ContractGuarantor interface.
 */
export function instanceOfContractGuarantor(value: object): value is ContractGuarantor {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('civilityId' in value) || value['civilityId'] === undefined) return false;
    if (!('isCompleted' in value) || value['isCompleted'] === undefined) return false;
    if (!('employmentStatusId' in value) || value['employmentStatusId'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function ContractGuarantorFromJSON(json: any): ContractGuarantor {
    return ContractGuarantorFromJSONTyped(json, false);
}

export function ContractGuarantorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractGuarantor {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullName': json['fullName'],
        'civilityId': json['civilityId'],
        'isCompleted': json['isCompleted'],
        'employmentStatusId': json['employmentStatusId'],
        'documents': ((json['documents'] as Array<any>).map(ContractTenantDocumentFromJSON)),
    };
}

export function ContractGuarantorToJSON(json: any): ContractGuarantor {
    return ContractGuarantorToJSONTyped(json, false);
}

export function ContractGuarantorToJSONTyped(value?: ContractGuarantor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fullName': value['fullName'],
        'civilityId': value['civilityId'],
        'isCompleted': value['isCompleted'],
        'employmentStatusId': value['employmentStatusId'],
        'documents': ((value['documents'] as Array<any>).map(ContractTenantDocumentToJSON)),
    };
}

